import React from 'react'

export const CustomDropdownIndicator = (props) => {
    return (
      <div className="custom-arrow-zone">
        <span className="custom-arrow"></span>
      </div>
    )
  }